import { useSelector } from "react-redux";
import { RootState } from "State/store";

export const useSelectedTemplate = () =>
  useSelector((state: RootState) => state.template.selected);
